// Copyright (c) 2018 Deere & Company

import actions from '../../action-list';
import {getDefaultState as getClaimDefaultState} from '../state';

const updateIsActionButtonDisabled = (state, action) =>
    action.isDisabled;

export default (state = getClaimDefaultState().isActionButtonDisabled, action) => {

    const actionTypes = {
        [actions.UPDATE_CLAIM_BATTERY_IS_ACTION_BUTTON_DISABLED]: updateIsActionButtonDisabled
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/battery/reducers/is-action-button-disabled.js